import React, { Component } from 'react';

import '../css/bg.css';
import '../css/main-page.css';
import '../css/gallery.css';

import routeConfig from '../config/route.json';
import comingSoonConfig from '../config/coming-soon.json';

import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars';


class Gallery extends Component {

  constructor(props) {
    super(props);
    let lang = window.location.hash.split('/')[1];


    this.state = {
      ...this.props,
      bg: {
        'pic1': '/bg/' + lang + '/gallary/main.png',
        'pic2': '/bg/' + lang + '/gallary/back-1.png',
        'pic3': '/bg/' + lang + '/gallary/back-2.png',
        'pic4': '/bg/' + lang + '/gallary/front-1.png',
        'pic5': '/bg/' + lang + '/gallary/front-2.png'
      },
      lang: lang,
      imageIndex: 0,
      image: ''
    }
    this.openImage = this.openImage.bind(this);
    this.closeImage = this.closeImage.bind(this);
    this.closeImage = this.closeImage.bind(this);
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;
    
    this.t1 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
      t.changePositioning();
    }, 500);
    this.t2 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
      t.changePositioning();
    }, 1500);
    this.t3 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
      t.changePositioning();
    }, 2500);
    this.t4 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
      t.changePositioning();
    }, 4000);
    this.t5 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
      t.changePositioning();
    }, 7000);

    console.log("Gallery DidMount")
    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
    });

    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);

  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);

    clearTimeout(this.t1);
    clearTimeout(this.t2);
    clearTimeout(this.t3);
    clearTimeout(this.t4);
    clearTimeout(this.t5);

    this.closeImage();
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();
    setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
    setTimeout(function(){
      document.getElementById('bg-image-5').classList.remove('bg-flower');
    }, 4700);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage2Top = windowWidth * 0.332 + 'px';

    document.getElementById('bg-image-2-container').style.top = bgImage2Top;



    // let mainPageContentContainer1Top = windowWidth * 0.363 + 'px';

    // document.getElementById('main-page-content-container-1').style.top = mainPageContentContainer1Top;

    // padding: 5% 0 0 0;
    $('.gallary-image-pre').css({
      'height': $('.gallary-image-pre').width() * 0.5 + 'px',
      'padding': $('.gallary-image-pre').width() * 0.33 + 'px 0 0 0'
    })
    
  }



  openImage(imgIdx){
    
    this.setState({
      'imageIndex': imgIdx,
      'image': this.state.data.gallery[imgIdx].img
    })

    $('.gallary-image').fadeIn()
    $('#App-header').fadeOut()
    $('#App-footer').fadeOut()
  }

  closeImage(){
    this.setState({
      'image': ''
    })
    $('.gallary-image').fadeOut()
    $('#App-header').fadeIn()
    $('#App-footer').fadeIn()
  }

  changeImage(move) {
    let t = this;
    let nowIdx = t.state.imageIndex;
    let nextIdx = 0;

    let result = 0;
    // function nextIdxer(){
    //   console.log(nextIdx)

    //   if (!t.state.data.gallery[nextIdx]) {
    //     nextIdx = nextIdx - move;
    //     return;
    //   } else
    //   if (!t.state.data.gallery[nextIdx].img) {
    //     nextIdx = nextIdx + move;
    //     nextIdxer()
    //   }

    // }

    function nextIdxer(nowIdx, move){
      if (!t.state.data.gallery[nowIdx + move]) {
        return -1;
      } else
      if (!t.state.data.gallery[nowIdx + move].img) {
        return nextIdxer(nowIdx + move, move)
      } else {
        return nowIdx + move
      }
    }

    result = nextIdxer(nowIdx, move)
    if (result === -1) {
      nextIdx = nowIdx
    } else {
      nextIdx = result
    }

    console.log(nextIdx)

    this.setState({
      'imageIndex': nextIdx,
      'image': t.state.data.gallery[nextIdx].img
    })
  }
  
  render() {
    let t = this;
    return <div className="main-page" style={{}}>
        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            'right': '3px',
            'width': '30%'
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>

        <div id='bg-image-3-container'
          className='bg-image-container'
          style={{
            'width': '53%'
          }}>
          <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
        </div>

        <img src={this.state.bg.pic1} className='bg-image main-bg-image' id='bg-image-1' style={{
          
        }}/>

        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            'right': '3px',
            'width': '30%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4' style={{}}/>
        </div>
        <div id='bg-image-5-container'
          className='bg-image-container'
          style={{
            'width': '20%'
          }}>
          <img src={this.state.bg.pic5} className='bg-image bg-flower' id='bg-image-5'/>
        </div>

        <div id='main-page-content-container-1'
          className='main-page-content-container'
          style={{
            'left': '18%',
            'width': '64%',
            'top': '53%',
            'height': '200px',
            'maxWidth': '100%'
          }}>

          <div
            className='main-page-content-subtitle'
            style={{
              'textAlign': 'center',
              'fontSize': '16px',
              'textShadow': '1px 1px 2px rgba(0,0,0,1)'
            }}>
            {this.state.lang === 'en' ? 
              <img style={{'height': '44px'}} src={routeConfig.gallery[this.state.lang].titleUrl}/> : 
              routeConfig.gallery[this.state.lang].name
            }
          </div>

          <Scrollbars
              renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
              renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>}
              // renderTrackVertical={props => <div {...props} className="track-vertical"/>}
              // renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}   
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              className=''
              style={{
                'overflowX': 'hidden',
                'whiteSpace': 'nowrap',
                'top': '20%'
              }}>

            {this.state.data && this.state.data.gallery && this.state.data.gallery.length > 0 ?
              this.state.data.gallery.map(function(elem, idx){
                let renderType = elem.img ? 'img' : 'pdf';
                let objToRender = '';
                if (renderType === 'img') {
                  let imgSrc = 'url(' + elem.img + ')';
                  objToRender = <div key={idx} className='gallary-image-pre' style={{
                    'backgroundImage': imgSrc
                  }} onClick={() => t.openImage(idx)}>
                  </div>
                }
                else {
                  objToRender = <a key={idx} href={elem.url} target='_blank'><div className='gallary-image-pre' style={{
                    'color': 'white',
                    'fontFamily': 'Roboto Condensed, sans-serif'
                  }}>
                    {elem[t.state.lang]}
                  </div></a>
                }
                return objToRender

              }) : <div style={{
                  'color': 'white',
                  'padding': '6px 0',
                  'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
                  'textAlign': 'center'
                }}>{comingSoonConfig[t.state.lang]}</div>
              }

          </Scrollbars>

        </div>


        <div className='gallary-image' style={{
          
        }}>

            <img src={this.state.image} className='centering' style={{
              'maxWidth': '82%',
              'maxHeight': '95%'
            }}/>
          <img src='/gallery/left.png' className='gallary-lr' style={{
            'left': '50px'
          }} onClick={() => t.changeImage(-1)}/>
          <img src='/gallery/right.png' className='gallary-lr' style={{
            'right': '50px'
          }} onClick={() => t.changeImage(1)}/>
          <i className='material-icons gallary-lr' style={{
            'top': '25px',
            'right': '25px',
            'fontSize': '50px',
            'color': 'rgb(51, 102, 199)'
          }} onClick={this.closeImage}>clear</i>
        </div>
        
    </div>
  }
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/page/Gallery.js